/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TopMenuAutoCommandsController", ["ControllerPlaceholderBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class TopMenuAutoCommandsController
   * @memberOf classes
   * @extends classes.ControllerPlaceholderBase
   */
  class TopMenuAutoCommandsController extends cls.ControllerPlaceholderBase /** @lends classes.TopMenuAutoCommandsController.prototype */ {
    static __name = "TopMenuAutoCommandsController";

    constructor(bindings) {
      super(bindings);
      this._autoWidgetType = "TopMenuCommand";

      if (bindings.anchor.attribute("content") === "actions") {
        this._registerActionHandlers();
      } else if (bindings.anchor.attribute("content") === "programs") {
        this._registerProgramsHandlers(false);
      } else if (bindings.anchor.attribute("content") === "windows") {
        this._registerWindowsHandlers(false);
      }
    }

    /**
     * @inheritDoc
     */
    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.FontStyle4STBehavior, true);
      this._addBehavior(cls.FontSize4STBehavior, true);
      this._addBehavior(cls.Border4STBehavior, true);
      this._addBehavior(cls.Reverse4STBehavior, true);
      this._addBehavior(cls.DefaultTTFColor4STBehavior);

      // vm behaviors
      this._addBehavior(cls.EnabledButtonVMBehavior);
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.TextActionVMBehavior);
      this._addBehavior(cls.ImageVMBehavior);
      this._addBehavior(cls.TitleVMBehavior);
    }

    /**
     * @inheritDoc
     */
    _getWidgetType(kind) {
      return "TopMenuPlaceholder";
    }
  }

  cls.TopMenuAutoCommandsController = TopMenuAutoCommandsController;
  cls.ControllerFactory.register("TopMenuAutoCommands", cls.TopMenuAutoCommandsController);
});
